import { Component, OnInit } from '@angular/core';
import { ConstantsService } from 'src/app/constants.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  signuphide: boolean;
  constructor(private _constantsService : ConstantsService) { 
    this._constantsService.getValue().subscribe((value) => {
      this.signuphide = value;
    });
  }
  scroll(id: string){
    document.getElementById(id).scrollIntoView({behavior: 'smooth', block: "start", inline: "nearest"});
  }
  ngOnInit() {
}

}
